import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import {cartRegister} from "../../services/cartRegister"
import {imagesRegister} from "../../services/imagesRegister"
import {quotesRegister} from "../../services/quotesRegister"
import cx from "classnames";
import Moment from 'react-moment';

class ModalStopCampaign extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    };

    componentWillMount() {}

    _close(){
        this.props.stop(false);
    }

    _terminate(){
        this.props.terminate();
    }

    _renderText(item) {
        return langRegister.get("modal-stopcampaign", item);
    }

    render() {
        return (
            <div className={Styles.overlay}>
                <div className={Styles.overlayModal}>
                    <div className={Styles.overlayModalInner}>
                        <img onClick={() => this._close()}
                             className={Styles.overlayCloseButton}
                             src={require("../../assets/images/close_icon.svg")}/>
                        <div>
                            <div className={Styles.overlayModalText}>
                                <span className={Styles.overlayModalTextRed}>{this._renderText("item_1")}{" "}</span><span className={Styles.overlayModalTextBold}>{this._renderText("item_2")}</span>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.overlayModalButtons}>
                        <div className={Styles.overlayModalButtonsItem}>
                            <div onClick={() => {this._close()}} className={cx([Styles.overlayModalButtonsItemButton])}>
                                {this._renderText("item_4")}
                            </div>
                        </div>
                        <div className={Styles.overlayModalButtonsItem}>
                            <div onClick={() => {this._terminate()}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                {this._renderText("item_3")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


/*
<span className={Styles.overlayModalTextGreen}>{this._renderText("item_2")}&nbsp;
                                  <Moment diff={this.state.today} unit="days" add={{ days: this.state.duration}}>{this.state.start_date}</Moment>
                                  &nbsp;{this._renderText("item_5")}</span>
 */

export default ModalStopCampaign;


// WEBPACK FOOTER //
// ./src/components/modal_stopcampaign/component.js